(function () {
  if (customElements.get('email-popup-modal')) return;

  class EmailPopupModal extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'imaginal_email_popup_dismissed';
      this.onKeydown = this.onKeydown.bind(this);
      this.open = this.open.bind(this);
    }

    connectedCallback() {
      this.querySelectorAll('[data-popup-close]').forEach((el) => {
        el.addEventListener('click', () => this.close());
      });

      const hasSuccess = !!this.querySelector('.email-popup__success');
      const hasError = !!this.querySelector('.email-popup__error');

      if (hasSuccess || hasError) {
        this.open();
        if (hasSuccess) this.markDismissed();
        return;
      }

      if (this.isDismissed()) return;

      const delay = parseInt(this.dataset.delay, 10) || 8000;
      const scrollThreshold = parseInt(this.dataset.scroll, 10) || 30;

      this.timeoutId = setTimeout(this.open, delay);

      this.onScroll = () => {
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        const pct = (window.scrollY / scrollable) * 100;
        if (pct >= scrollThreshold) this.open();
      };
      window.addEventListener('scroll', this.onScroll, { passive: true });
    }

    isDismissed() {
      try {
        const raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        const days = parseInt(this.dataset.cookieDays, 10) || 14;
        return Date.now() - parseInt(raw, 10) < days * 24 * 60 * 60 * 1000;
      } catch (e) {
        return false;
      }
    }

    markDismissed() {
      try {
        localStorage.setItem(this.storageKey, String(Date.now()));
      } catch (e) {
        /* ignore */
      }
    }

    open() {
      if (this.classList.contains('is-open')) return;
      clearTimeout(this.timeoutId);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      this.classList.add('is-open');
      document.body.classList.add('email-popup-open');
      document.addEventListener('keydown', this.onKeydown);
      const closeBtn = this.querySelector('.email-popup__close');
      if (closeBtn) closeBtn.focus();
    }

    close() {
      this.classList.remove('is-open');
      document.body.classList.remove('email-popup-open');
      document.removeEventListener('keydown', this.onKeydown);
      this.markDismissed();
    }

    onKeydown(event) {
      if (event.key === 'Escape') this.close();
    }
  }

  customElements.define('email-popup-modal', EmailPopupModal);
})();
